module.exports = __webpack_public_path__ + "img/10.d7e8d47a.jpg";